const Hero = () => {
  return (
    <header className="text-center">
      <div className="flex justify-center items-center">
        <img
          src="/escarole_logo.png"
          className="h-16 w-auto object-contain drop-shadow-sm"
          alt="Escarole logo - a healthier way to scroll"
          loading="eager"
          width="64"
          height="64"
        />
      </div>

      <h1 className="text-6xl text-emerald-900 md:text-9xl font-brand font-bold">
        escarole
      </h1>
      <p className="font-geist font-semibold uppercase tracking-[0.16em] text-[14px] text-emerald-800 mb-8 md:text-[16px] leading-6 md:leading-8 max-w-2xl mx-auto">
        the healthier way to scroll
      </p>
    </header>
  )
}

export default Hero
